<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Kontakt</h1>

        <p class="lead">Haben Sie Anregungen oder Fragen?</p>
        <p>Wir stehen Ihnen gerne unter <a
          href="mailto:medienarchiv68@axelspringer.de">medienarchiv68@axelspringer.de</a> zur Verfügung.</p>
        <h2>Impressum</h2>

        <b-media>
          <b-img slot="aside" thumbnail src="@/assets/261861674_d0dfdd9403.jpg" alt="Rainer Laabs" />
          <h3>Verantwortlich für den Inhalt</h3>

          <p>Lars-Broder Keil<br />
            Leiter Unternehmensarchiv<br />
            Axel Springer SE<br />
            Axel-Springer-Straße 65<br />
            10888 Berlin<br />
            Tel. 030-2591-73281<br />
            Fax 030-2591-71782<br />
            <a href="mailto:medienarchiv68@axelspringer.de">medienarchiv68@axelspringer.de</a>
          </p>

          <dl class="row">
            <dt class="col-sm-2">Firma</dt>
            <dd class="col-sm-10">Axel Springer SE <br /> Axel-Springer-Straße 65 <br /> 10888 Berlin</dd>
            <dt class="col-sm-2">Vorstand</dt>
            <dd class="col-sm-10">
              Dr. Mathias Döpfner (Vorsitzender)<br />
              Mark Dekan<br />
              Claudius Senst
            </dd>
            <dt class="col-sm-2">Amtsgericht</dt>
            <dd class="col-sm-10">Amtsgericht Charlottenburg <br /> USt-IdNr. DE 136 627 286</dd>
            <dt class="col-sm-2">Handelsregister</dt>
            <dd class="col-sm-10">Sitz Berlin<br /> HRB 154517 B</dd>
          </dl>
        </b-media>
        <h3>Information gemäß § 36 Verbraucherstreitbeilegungsgesetz</h3>
        <p>medienarchiv68.de nimmt an einem freiwilligen Streitbeilegungsverfahren vor einer deutschen
          Verbraucherschlichtungsstelle nicht teil. Eine gesetzliche Verpflichtung besteht nicht.</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'ContactPage',
    created () {
      store.commit('setBreadcrumb', ['Kontakt'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/ContactPage.vue